import * as React from "react";
import { AccuracySupplementalTypeEnum, NPIStatus } from "@app/projects/enumerators";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { JSX } from "react";

export const getSupplementalDataDecoration = (supplementValue: string | React.ReactNode, supplementalType: AccuracySupplementalTypeEnum, sourceData: string): JSX.Element => {
  switch (supplementalType) {
    case AccuracySupplementalTypeEnum.Valid:
      return (
        <div className="text-success">
          <QesIcon iconName={QesIcons.FontAwesome.Check} width="13" description="this information is valid" classNames="mx-2" />
          {typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}
        </div>
      );
    case AccuracySupplementalTypeEnum.Invalid:
      return (
        <div className="text-danger">
          <QesIcon iconName={QesIcons.FontAwesome.Times} width="10" description="this information is invalid" classNames="mx-2" />
          <s>{typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}</s>
        </div>
      );
    case (AccuracySupplementalTypeEnum.Enriched):
      return (
        <div>
          {sourceData &&
            <div className="text-danger">
              <QesIcon iconName={QesIcons.FontAwesome.Times} width="10" description="this information is invalid" classNames="mx-2" />
              <s>{sourceData}</s>
            </div>
          }
          <div className="text-info">
            <QesIcon iconName={QesIcons.FontAwesome.Star} width="12" description="this information is enriched" classNames="mx-2" />
            {typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}
          </div>
        </div>
      );

    default:
      return (
        <div className="text-muted">
          <QesIcon iconName={QesIcons.FontAwesome.Question} width="8" description="the accuracy of this information is unknown" classNames="mx-2" />
        </div>
      );
  }
};

export const getSupplementalDataDecorationWithoutSource = (supplementValue: string | React.ReactNode, supplementalType: AccuracySupplementalTypeEnum): JSX.Element => {
  switch (supplementalType) {
    case AccuracySupplementalTypeEnum.Valid:
      return (
        <div className="text-success">
          <QesIcon iconName={QesIcons.FontAwesome.Check} width="13" description="this information is valid" classNames="mx-2" />
          {typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}
        </div>
      );
    case AccuracySupplementalTypeEnum.Invalid:
      return (
        <div className="text-danger">
          <QesIcon iconName={QesIcons.FontAwesome.Times} width="10" description="this information is invalid" classNames="mx-2" />
          <s>{typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}</s>
        </div>
      );
    case (AccuracySupplementalTypeEnum.Enriched):
      return (
        <div>
          <div className="text-info">
            <QesIcon iconName={QesIcons.FontAwesome.Star} width="12" description="this information is enriched" classNames="mx-2" />
            {typeof supplementValue === "string" ? valueOrDashes(supplementValue) : supplementValue}
          </div>
        </div>
      );

    default:
      return (
        <div className="text-muted">
          <QesIcon iconName={QesIcons.FontAwesome.Question} width="8" description="the accuracy of this information is unknown" classNames="mx-2" />
        </div>
      );
  }
};

export const valueOrDashes = (value: string | NPIStatus | boolean | number, numberAsCurrency?: boolean): React.ReactNode => {
  let result: React.ReactNode = value;

  if (typeof result === "boolean") {
    result = result === undefined
      ? null
      : value
        ? "Y"
        : "N";
  }
  if (numberAsCurrency && (typeof result === "number")) {
    result = result
      ? `$${result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
      : result;
  }

  return result || "---";
};

export const bandDisplayNames = (bandGroup: string): string => {
  switch (bandGroup) {
    case "Accurate":
      return "Valid";
    case "Inaccurate":
      return "Invalid";
    case "Enriched":
    case "Skipped":
    case "Suspect":
    default:
      return bandGroup;
  }
}